import React from "react";
import { useParams } from "react-router-dom";
import {
    getStudentEvaluation,
    getStudentEvaluationMany
} from "../../API/evaluate";
import useRequest from "../../Utils/useRequest";
import EvaluateHeader from "./components/EvaluateMain/components/EvaluateHeader";
import EvaluateMain from "./components/EvaluateMain";

export default function Evaluate() {
    const { evaluationId, multiEvaluationFlag } = useParams<{
        evaluationId: string;
        multiEvaluationFlag: string;
    }>();
    const [data, , reloadData] = useRequest(
        () => {
            if (multiEvaluationFlag === "0") {
                return getStudentEvaluation({ evaluationId });
            } else {
                return getStudentEvaluationMany({ evaluationId });
            }
        },
        {},
        []
    );

    if (!data) {
        return null;
    }

    return (
        <>
            {data && (
                <EvaluateMain
                    data={data}
                    reloadData={reloadData}
                    headerDom={<EvaluateHeader data={data} />}
                />
            )}
        </>
    );
}
